<template>
  <group-component
    v-if="!isMobileView && orientation === 'horizontal'"
    :id="id"
    header="Search Criteria"
    :collapsible="true"
    :collapsed="collapsed">
    <slot></slot>
  </group-component>
  <div
    v-else
    :id="id"
    :class="{
      'group': true,
      'nextgen-filter-group': true,
      'twocolumn-layout__left': orientation === 'vertical' && !isMobileView,
      'collapse': true,
      'hidden': !filtersExpanded,
      'shown': filtersExpanded,
      'mobile': isMobileView
    }">
    <button
      class="collapse-icon filter-button valid"
      type="button"
      aria-haspopup="dialog"
      @click="toggleFilters(true)">
      <span class="ui-icon"></span>
      <span class="header__text"
        >Show Search Criteria
        <span v-if="isMobileView && activeFilters >= 0">
          <span class="filter-group-count">{{ activeFilters }}</span>
          applied</span
        >
      </span>
    </button>
    <component
      :is="isMobileView ? 'dialog' : 'div'"
      ref="filtersContainer"
      :class="{
        'nextgen-filters-container': true
      }"
      :aria-label="isMobileView ? 'Search Filters' : null"
      :role="isMobileView ? 'dialog' : null"
      :aria-modal="isMobileView ? true : null"
      @close="isMobileView ? toggleFilters(false) : null">
      <button
        v-if="isMobileView"
        class="dialog-close-button"
        type="button"
        :aria-label="
          activeFilters >= 0
            ? 'Close Filters Dialog - ' + activeFilters + ' applied'
            : 'Close Filters Dialog'
        "
        @click="toggleFilters(false)">
        <span class="ui-icon ui-icon-triangle-1-s"></span>
        <span
          v-if="isMobileView && activeFilters >= 0"
          class="filter-group-count"
          aria-hidden="true"
          >{{ activeFilters }}</span
        >
      </button>
      <div class="rect group__inner">
        <slot></slot>
        <div
          v-if="isMobileView && addExtraSpace"
          class="newline"
          style="height: 40px"></div>
        <div class="nextgen-filter-buttons">
          <button
            v-if="showSearchButton"
            type="button"
            class="button instant-overlay primary"
            @click.prevent="onFiltersSearch">
            Search
          </button>
          <button
            v-if="showResetButton"
            type="button"
            class="button tertiary"
            @click.prevent="onFiltersReset">
            Reset
          </button>
        </div>
      </div>
    </component>
  </div>
</template>

<script>
export default {
  name: 'SearchFiltersComponent',
  emits: ['applyFilters', 'resetFilters'],
  props: {
    id: String,
    orientation: String,
    collapsed: Boolean,
    activeFilters: Number,
    addExtraSpace: Boolean,
    searchButton: Object,
    resetButton: Object
  },
  computed: {
    showSearchButton() {
      return (
        (this.isMobileView && this.searchButton.mobile) ||
        (!this.isMobileView && this.searchButton.desktop)
      )
    },
    showResetButton() {
      return (
        (this.isMobileView && this.resetButton.mobile) ||
        (!this.isMobileView && this.resetButton.desktop)
      )
    }
  },
  data() {
    return {
      isMobileView: false,
      filtersExpanded: false
    }
  },
  mounted() {
    this.checkIfMobileView()
    window.addEventListener('resize', this.checkIfMobileView)
    document.addEventListener('orientationchange', this.checkIfMobileView)
  },
  unmounted() {
    window.removeEventListener('resize', this.checkIfMobileView)
    document.removeEventListener('orientationchange', this.checkIfMobileView)
  },
  methods: {
    checkIfMobileView() {
      if (document.documentElement.clientWidth <= 991.98) {
        this.isMobileView = true
      } else {
        this.isMobileView = false
      }
    },

    toggleFilters(open) {
      if (this.isMobileView) {
        if (open) {
          this.filtersExpanded = true
          this.$refs.filtersContainer.showModal()
        } else {
          this.filtersExpanded = false
          this.$refs.filtersContainer.close()
        }
      }
    },

    onFiltersSearch() {
      this.toggleFilters(false)
      this.$emit('applyFilters')
    },

    onFiltersReset() {
      this.toggleFilters(false)
      this.$emit('resetFilters')
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/abstract/variables.less';
@import '../assets/css/abstract/mixins.less';

.nextgen-filter-group {
  margin: 0px 30px !important;
}

.nextgen-filter-buttons {
  display: flex;
  flex-direction: column;

  button {
    margin: 0;
  }

  .primary {
    .default-focus-indicator(2px, @primary-color);
  }

  .tertiary {
    .default-focus-indicator(0, @primary-color);
  }
}

@media @tablet-down {
  .nextgen-filter-buttons {
    flex-direction: row;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;

    button {
      height: 48px;
      line-height: 48px;
      border-radius: 0;
      opacity: 1 !important;
    }

    .primary {
      .default-focus-indicator(-6px, @primary-text-color);
    }

    .tertiary {
      .default-focus-indicator(-3px, @primary-color);
    }
  }
}
</style>
